<div class="lists-container">
    <div
        #draggableList="cdkDropList"
        class="section-list"
        id="draggableList"
        cdkDropList
        [cdkDropListData]="draggableSectionsList"
        [cdkDropListConnectedTo]="[orderedList]"
        cdkDropListOrientation="vertical"
        (cdkDropListDropped)="drop($event)"
    >
        <div class="section-box-dragged" *ngFor="let section of draggableSectionsList" cdkDrag>
            <div *cdkDragPlaceholder></div>
            {{ section.descriptionKey | i18next }}
        </div>
    </div>

    <div
        #orderedList="cdkDropList"
        class="section-list"
        id="orderedList"
        cdkDropList
        [cdkDropListData]="orderedSectionsList"
        [cdkDropListConnectedTo]="[draggableList]"
        cdkDropListOrientation="vertical"
        (cdkDropListDropped)="drop($event)"
    >
        <div
            *ngFor="let section of orderedSectionsList"
            cdkDrag
            [ngClass]="{
                'section-box-drag-disabled': section != null && section.fixed,
                'section-box-dragged': section != null && !section.fixed
            }"
            [cdkDragDisabled]="section != null && section.fixed"
        >
            <ng-container *ngIf="section != null && section.fixed">
                {{ section.descriptionKey | i18next }}
            </ng-container>
            <ng-container *ngIf="section != null && !section.fixed">
                <div *cdkDragPlaceholder></div>
                {{ section.descriptionKey | i18next }}
            </ng-container>
        </div>
    </div>
</div>
